import {alias, createModelSchema, raw} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";
import {Metadata} from "@/common/Metadata";

export class MapModel extends BaseObject {

    constructor() {
        super();
        this._checksum = "";
        this._created = 0;
        this._id = "";
        this._name = "";
        this._custom_name = "";
        this._size = "";
        this._type = "";
        this._updated = 0;
        this._version = 0;
        this._owner = null;
        this._minver = null;
        this._maxver = null;
        this._aud = null;
    }

    get minver() {return this._minver;}
    set minver(value) {this._minver = value;}

    get maxver() {return this._maxver;}
    set maxver(value) {this._maxver = value;}

    get aud() {return this._aud;}
    set aud(value) {this._aud = value;}

    get owner() {return this._owner;}
    set owner(value) {this._owner = value;}

    get checksum() {return this._checksum;}
    set checksum(value) {this._checksum = value;}

    get created() {return this._created;}
    set created(value) {this._created = value;}

    get id() {return this._id;}
    set id(value) {this._id = value;}

    get name() {return this._name;}
    set name(value) {this._name = value;}

    get custom_name() {return this._custom_name;}
    set custom_name(value) {this._custom_name = value;}

    get size() {return this._size;}
    set size(value) {this._size = value;}

    get type() {return this._type;}
    set type(value) {this._type = value;}

    get updated() {return this._updated;}
    set updated(value) {this._updated = value;}

    get version() {return this._version;}
    set version(value) {this._version = value;}

    copy() {
        return super.copy();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new MapModel());
        } else if (target instanceof MapModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(MapModel, {
    _checksum: alias("checksum", Schema.primitive()),
    _created: alias("created", Schema.primitive()),
    _id: alias("id", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _custom_name: alias("custom_name", Schema.primitive()),
    _size: alias("size", Schema.primitive()),
    _type: alias("type", Schema.primitive()),
    _updated: alias("updated", Schema.primitive()),
    _version: alias("version", Schema.primitive()),
    _owner: alias("owner", Schema.primitive()),
    _minver: alias("minver", Schema.primitive()),
    _maxver: alias("maxver", Schema.primitive()),
    _aud: alias("aud", Schema.primitive()),
});